/** Fields used when rendering an employee in assignment selects / chips. */
export type EmployeeLabelInput = {
  first_name?: string | null
  last_name?: string | null
  employee_number?: string | number | null
}

/**
 * Consistent employee display for assignment dropdowns.
 * Example: `#104 — Jane Doe` (falls back to name only when no number).
 */
export function formatEmployeeLabel(emp: EmployeeLabelInput | null | undefined): string {
  const name = [emp?.first_name, emp?.last_name].filter(Boolean).join(' ').trim()
  const num =
    emp?.employee_number != null && String(emp.employee_number).trim() !== ''
      ? String(emp.employee_number).trim()
      : ''
  if (num && name) return `#${num} — ${name}`
  if (num) return `#${num}`
  return name || '—'
}
